module.exports = __webpack_public_path__ + "static/media/job-description.b8d1fee6.pdf";